import { TopicType } from "../constant/enums";

export const sendChatReady = () => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.CHAT_READY }),
    "*",
  );
};

export const goToTicket = (ticketId) => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.GO_TO_TICKET, value: ticketId }),
    "*",
  );
};

export const goToChat = () => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.GO_TO_CHAT }),
    "*",
  );
};

export const sendNotifyIziMessageSuccess = (text) => {
  window.parent.postMessage(
    JSON.stringify({
      topic: TopicType.IZI_MESSAGE_NOTIFY,
      text,
      type: "success",
    }),
    "*",
  );
};

export const sendNotifyIziMessageError = (text) => {
  window.parent.postMessage(
    JSON.stringify({
      topic: TopicType.IZI_MESSAGE_NOTIFY,
      text,
      type: "error",
    }),
    "*",
  );
};

export const sendNotifyChatSuccess = (text) => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.CHAT_NOTIFY, text, type: "success" }),
    "*",
  );
};

export const sendNotifyChatError = (text) => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.CHAT_NOTIFY, text, type: "error" }),
    "*",
  );
};

export const sendWidgetReady = () => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.INITIALIZED }),
    "*",
  );
};

export const requestTrackingInfo = () => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.REQUEST_TRACKING_INFO }),
    "*",
  );
};

export const sendStyleIframe = (style) => {
  window.parent.postMessage(
    JSON.stringify({ topic: TopicType.STYLE_IFRAME, style }),
    "*",
  );
};
